module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('mu-paper', {
    staticClass: "searchReminder",
    staticStyle: {
      "position": "relative",
      "z-index": "99"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('mu-list-item', {
    attrs: {
      "disableRipple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.searchTerm)
    }
  })]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.results.length)
    }
  }), _vm._v(" of "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.options.total_results + ' ' + _vm.$t('message.labelFoods'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack.apply(null, arguments)
      }
    },
    slot: "left"
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "resultScroller"
    }
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.results.length === 0) ? _c('mu-list', {
    staticClass: "oddEven"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$t('message.labelFoodSearchResultsEmpty')
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "warning"
    },
    slot: "left"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.results.length >= 1) ? _c('mu-list', {
    staticClass: "oddEven"
  }, [_vm._l((_vm.results), function(result, index) {
    return _c('mu-list-item', {
      key: 'result-' + index,
      attrs: {
        "describeText": result.food_description,
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectFood(result)
        }
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "textContent": _vm._s(result.food_name)
      },
      slot: "title"
    }), 0, 'result-' + index), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "describe"
      },
      domProps: {
        "textContent": _vm._s(result.food_description)
      },
      slot: "describe"
    }), 1, 'result-' + index), _vm._v(" "), _vm._o(_c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "add_circle"
      },
      slot: "right"
    }), 2, 'result-' + index)], 1)
  }), _vm._v(" "), (!_vm.isAppending && _vm.options.total_results > _vm.results.length) ? _c('div', {
    attrs: {
      "id": "infinite-scroll-detector"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isAppending) ? _c('div', {
    staticStyle: {
      "padding": "24px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-993728ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FoodDiary/SearchResults/SearchResults.vue
// module id = 3821
// module chunks = 1